// extracted by mini-css-extract-plugin
export default {"sidebar":"m9HGa","content":"EJNaM"};